import React, { useEffect, useState } from 'react'
import { Modal, Button, Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
function Room({ room, fromdate, todate }) {
	const [show, setShow] = useState(false);
	const navigate = useNavigate();
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);


	    useEffect(() => {
				AOS.init({ duration: 500 });
				
			}, []); 
	return (
		<div  data-aos="zoom-in-up" className="row bs">
			<div className="col-md-4">
				<img src={room.imageurls[0]} className="smallimg" />
			</div>
			<div className="col-md-7 text-end">
				<h1>{room.name}</h1>
				<p>Max Count:{room.maxcount}</p>
				<p>Phone Number: {room.phonenumber}</p>
				<p>Type: {room.type}</p>
				<p>Rent Pre Day: ₦{room.rentperday}</p>

				<div style={{ float: "right" }}>
					{fromdate && todate && (
						<button
							className="btn btn-primary m-2"
							onClick={() => {
								navigate(`/book/${room._id}/${fromdate}/${todate}`);
							}}>
							Book New
						</button>
					)}

					<button className="btn btn-primary" onClick={handleShow}>
						View Details
					</button>
				</div>
			</div>

			<Modal show={show} onHide={handleClose} size="lg">
				<Modal.Header>
					<Modal.Title>{room.name}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Carousel>
						{room.imageurls.map((url) => {
							return (
								<Carousel.Item>
									<img
										className="d-block w-100 bigimg"
										src={url}
										alt="First slide"
									/>
								</Carousel.Item>
							);
						})}
					</Carousel>
					<p>{room.description}</p>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}

export default Room